import React from 'react';

export const CheckRing = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9" stroke="#8C67C9" />
      <path d="M8 12L11 15L16 9" stroke="#8C67C9" />
    </svg>
  );
};
